import { useEffect, useState } from "react";
import { loadCms } from "./loadCms";
import { SERVICES_FALLBACK } from "@/constants/cmsFallback";

/**
 * Read published Services from the Payload CMS collection.
 * Same resilience pattern: cache → live fetch with retries → static baseline
 * fallback. Sorted by the CMS response (Payload honours the sort param) and
 * defensively re-sorted client-side by `number` in case the fallback runs.
 */
export function useServices() {
  const [state, setState] = useState({
    data: { docs: SERVICES_FALLBACK },
    loading: true,
    source: "fallback",
  });

  useEffect(() => {
    return loadCms(
      "/api/cms/api/services?limit=100&sort=number&where[_status][equals]=published",
      "mts:services:v1",
      { docs: SERVICES_FALLBACK },
      setState
    );
  }, []);

  const docs = state?.data?.docs || SERVICES_FALLBACK;
  const services = [...docs].sort((a, b) =>
    String(a?.number || "").localeCompare(String(b?.number || ""))
  );
  return { services, loading: state.loading, source: state.source };
}
